const permission = {
    state: {},
    mutations: {},
    actions: {}
}

export default permission;